const isCalendarDate = (year: number, month: number, day: number) => {
  const date = new Date(Date.UTC(year, month - 1, day));
  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
};

/**
 * Returns a displayable/persistable MRN, or an empty string when a legacy
 * patient record accidentally put a calendar date in the MRN field.
 */
export function normalizePatientMrn(value: unknown): string {
  const mrn = String(value ?? '').trim();
  if (!mrn) return '';

  const monthFirst = mrn.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{2}|\d{4})$/);
  if (monthFirst) {
    const [, monthText, dayText, yearText] = monthFirst;
    const year =
      yearText.length === 2 ? 2000 + Number(yearText) : Number(yearText);
    if (isCalendarDate(year, Number(monthText), Number(dayText))) return '';
  }

  const yearFirst = mrn.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
  if (
    yearFirst &&
    isCalendarDate(
      Number(yearFirst[1]),
      Number(yearFirst[2]),
      Number(yearFirst[3]),
    )
  ) {
    return '';
  }

  return mrn;
}
